
<template>
  <div class="toCheck_box">
    <!-- 检测报告 -->
    <div class="check_box">
      <div class="head_bg">
        <p>{{userInfo.name}}的信用评分</p>
        <p class="score">{{blackInfo.grade}}分 <span :class="{'score_img1':blackInfo.grade<=50,'score_img2':blackInfo.grade<=65&&blackInfo.grade>50,'score_img3':blackInfo.grade<=90&&blackInfo.grade>65,'score_img4':blackInfo.grade>90}"></span></p>
      </div>
      <div class="userInfo">
        <ul>
          <li>
            <p class="userkey">手机号码</p>
            <p class="userValue">{{userInfo.mobile?util.checkPhone(userInfo.mobile):''}}</p>
          </li>
          <li>
            <p class="userkey">身份证号</p>
            <p class="userValue">{{userInfo.idCard?util.checkIdCard(userInfo.idCard,6,4):''}}</p>
          </li>
          <li>
            <p class="userkey">查询时间</p>
            <p class="userValue">{{userInfo.gmtCreated?userInfo.gmtCreated.substr(0,10):''}}</p>
          </li>
        </ul>
      </div>
      <div class="item">
        <p class="comn_title"><span class="line_bg"></span>个人风险评估</p>
        <div class="item_con">
          <div class="flex">
            <p class="item_key">是否列入风险黑名单？</p>
            <p class="item_value"
               :class="{'item_value_red':blackInfo.finalDecision}">{{changeStatus(blackInfo.finalDecision)}}</p>
          </div>
          <div class="item_info">
            解读：被列入黑名单基本借不到钱。<span class="color_bg">建议15天检测一次，维护个人信用，借钱从此无忧</span>
          </div>
        </div>
      </div>
      <div class="item">
        <p class="comn_title"><span class="line_bg"></span>多头借贷</p>
        <div class="box">
          <div class="noData_box"
               v-if="!isShowEchart">
            <span class="noData"></span>
          </div>
          <Echarts :dataList="dataList"
                   v-else></Echarts>
          <div class="box_con">
            <p><span class="squire"></span>网贷机构申请 <span class="appColor"
                    :class="{'red':blackInfo.strcutrueApply>0}">{{blackInfo.strcutrueApply}}</span> 次</p>
            <p><span class="squire1"></span>消费金融申请 <span class="appColor"
                    :class="{'red':blackInfo.expenseApply>0}">{{blackInfo.expenseApply}}</span> 次</p>
          </div>
        </div>
        <div class="item_con">
          <div class="flex_box bg">
            <div class="flex bg2">
              <p class="item_key">在小贷机构申请极为频繁</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.ruleNameCAE005}">{{changeStatus(blackInfo.ruleNameCAE005)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key">在网络小贷机构申请极为频繁</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.ruleNameCAE006}">{{changeStatus(blackInfo.ruleNameCAE006)}}</p>
            </div>
            <div class="flex bg2">
              <p class="item_key">在消费金融机构申请极为频繁</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.ruleNameCAE007}">{{changeStatus(blackInfo.ruleNameCAE007)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key">申请线下消费分期极为频繁</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.ruleNameCAE014}">{{changeStatus(blackInfo.ruleNameCAE014)}}</p>
            </div>
            <div class="flex bg2">
              <p class="item_key">申请线上现金分期极为频繁</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.ruleNameCAE015}">{{changeStatus(blackInfo.ruleNameCAE015)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key">申请信用卡极为频繁</p>
              <p class="item_value"
                 :class="{'item_value_red':blackInfo.ruleNameCAE017}">{{changeStatus(blackInfo.ruleNameCAE017)}}</p>
            </div>
          </div>
          <div class="item_info">
            解读：多头借贷，指借款人向多家金融机构提出借贷需求的行为。因借款人的偿还能力有限，向多方借贷可能蕴含着较高的还款风险。此结果仅统计12个月的数据。
          </div>
        </div>
      </div>
      <div class="item">
        <p class="comn_title"><span class="line_bg"></span>公检信息排查</p>
        <div class="item_con">
          <div class="flex_box bg">
            <div class="flex bg2">
              <p class="item_key">法院失信名单</p>
              <p class="item_value"
                 :class="{'item_value_red':proseInformation.idCourtBad}">{{changeStatus(proseInformation.idCourtBad)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key">法院被执行人</p>
              <p class="item_value"
                 :class="{'item_value_red':proseInformation.idCourtExecuted}">{{changeStatus(proseInformation.idCourtExecuted)}}</p>
            </div>
            <div class="flex bg2">
              <p class="item_key">公安信息异常</p>
              <p class="item_value"
                 :class="{'item_value_red':proseInformation.badInfo}">{{changeStatus(proseInformation.badInfo)}}</p>
            </div>
          </div>
          <div class="item_info">
            解读：命中风险越多，审核通过率越低，建议保持良好信用。
          </div>
        </div>
      </div>
      <div class="item">
        <p class="comn_title"><span class="line_bg"></span>金融行业风险排查</p>
        <div class="item_con">
          <div class="flex_box bg">
            <div class="flex bg2">
              <p class="item_key">银行类金融机构风险</p>
              <p class="item_value"
                 :class="{'item_value_red':financialIndustry.bankMoneyType}">{{changeStatus(financialIndustry.bankMoneyType)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key">挂牌小贷机构风险</p>
              <p class="item_value"
                 :class="{'item_value_red':financialIndustry.smallLoans}">{{changeStatus(financialIndustry.smallLoans)}}</p>
            </div>
            <div class="flex bg2">
              <p class="item_key">挂牌网贷机构风险</p>
              <p class="item_value"
                 :class="{'item_value_red':financialIndustry.netCredit}">{{changeStatus(financialIndustry.netCredit)}}</p>
            </div>
            <div class="flex bg1">
              <p class="item_key">挂牌消费金融机构风险</p>
              <p class="item_value"
                 :class="{'item_value_red':financialIndustry.consumerFinance}">{{changeStatus(financialIndustry.consumerFinance)}}</p>
            </div>
          </div>
          <div class="item_info">
            解读：命中风险越多，审核通过率越低，建议保持良好信用。
          </div>
        </div>
      </div>
      <div class="item">
        <p class="comn_title"><span class="line_bg"></span>报告数据说明</p>
        <div class="item_con">
          <div class="item_notice">
            1、风险信用评估报告是由用户本人授权查询。<br>
            2、报告内容以第三方平台数据为依据，报告仅供参考，据此作出的决策均为用户独立的判断，产生的一切结果均由用户独立承担，77信用不承担任何责任。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PayToast from '@/components/payToast';
import Echarts from '@/components/echarts'
export default {
  components: {
    // Head,
    Echarts,
    PayToast
  },
  data () {
    return {
      dataList: [
        { value: 0, name: '网贷机构申请' },
        { value: 0, name: '消费金融申请' },
      ],
      eventKey: 'h5_blacklist_view',
      userInfo: {
        mobile: '',
        idCard: '',
        gmtCreated: ''
      },
      score: 0,//是否可以检测
      blackInfo: {
        balckInfo: {
          strcutrueApply: 0,
          expenseApply: 0,
        }
      },//借贷信息
      isShowEchart: true,
      financialIndustry: {},//金融信息
      proseInformation: {},//公检信息
    }
  },
  mounted () {
    this.util.title('个人信用评估');
    this.getHitInfo();//获取检测信息
  },
  beforeDestroy () {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    getHitInfo () {
      let _this = this;
      this.$get('/app/h5/blackList/newHitInfo')
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.userInfo = e.data.byConsumerId;
            _this.blackInfo = e.data.blackInfo.blackInfo;
            _this.financialIndustry = e.data.blackInfo.financialIndustry;
            _this.proseInformation = e.data.blackInfo.proseInformation;
            _this.dataList[0].value = e.data.blackInfo.blackInfo.strcutrueApply;
            _this.dataList[1].value = e.data.blackInfo.blackInfo.expenseApply;
            if (e.data.blackInfo.blackInfo.strcutrueApply == 0 && e.data.blackInfo.blackInfo.expenseApply == 0) {
              _this.isShowEchart = false;
            } else {
              _this.isShowEchart = true;
            }
          }
          else {
            _this.util.toast({ msg: e.msg })
          }
        })
        .catch(error => { });
    },
    changeStatus (val) {
      if (val) {
        return "命中"
      } else {
        return "未命中"
      }
    },
  }

}
</script>
<style scoped>
.check_box {
  position: relative;
  background: #f7f7f7;
  top: 0;
}
/* 检测报告 */
.check_box .head_bg {
  background: url("../../assets/img/vip/check/checkBox_bg.png") no-repeat top
    center;
  background-size: 100% 100%;
  width: 100%;
  height: 1.54rem;
  color: #fff;
  font-family: AlibabaPuHuiTiM;
  font-size: 0.28rem;
  padding: 0.34rem 0 0.35rem 0.23rem;
}
.score {
  font-size: 0.34rem;
}
.score_img4,
.score_img1,
.score_img2,
.score_img3 {
  background: url("../../assets/img/vip/check/score_bg1.png") no-repeat top
    center;
  background-size: 100% 100%;
  display: inline-block;
  width: 0.48rem;
  height: 0.24rem;
}
.score_img2 {
  background: url("../../assets/img/vip/check/score_bg2.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.score_img3 {
  background: url("../../assets/img/vip/check/score_bg3.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.score_img4 {
  background: url("../../assets/img/vip/check/score_bg4.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.userInfo {
  margin-bottom: 0.1rem;
  background: #fff;
}
.userInfo li {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  padding: 0.13rem 0;
  margin: 0 0.15rem;
}
.userInfo .userKey {
  color: #333;
  font-size: 0.15rem;
}
.userInfo .userValue {
  font-size: 0.14rem;
  color: #999;
}
.item {
  background: #fff;
  margin-bottom: 0.1rem;
}
.comn_title {
  color: #333;
  font-size: 0.14rem;
  padding: 0.14rem 0.15rem;
  border-bottom: 1px solid #f5f5f5;
}
.line_bg {
  display: inline-block;
  width: 0.04rem;
  height: 0.13rem;
  background: linear-gradient(
    135deg,
    rgba(89, 131, 252, 1) 0%,
    rgba(60, 113, 246, 1) 100%
  );
  position: relative;
  top: 0.015rem;
  margin-right: 0.05rem;
}
.item_con {
  padding: 0.15rem 0.25rem 0.2rem 0.25rem;
  clear: both;
  overflow: hidden;
}
.item .box {
  clear: both;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  padding-left: 0.6rem;
  padding-right: 0.5rem;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.item_key {
  font-size: 0.14rem;
  color: #333;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 400;
}
.item_value {
  font-size: 0.14rem;
  color: #4f8cfa;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.item_value_red {
  color: #ff3e3e;
}
.item_info {
  color: #999;
  font-size: 0.12rem;
  margin-top: 0.15rem;
  line-height: 23px;
}
.color_bg {
  color: #ffa249;
  font-size: 0.12rem;
  background: rgba(255, 162, 73, 0.1);
}
.item_con .bg {
  border-radius: 6px;
  border: 1px solid rgba(234, 244, 255, 1);
}
.flex_box .bg2 {
  background: rgba(244, 250, 255, 1);
  padding: 0.1rem;
}
.flex_box .bg1 {
  background: rgba(244, 250, 255, 0.3);
  padding: 0.1rem;
}
.item_notice {
  font-size: 0.14rem;
  color: #999;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 28px;
}
.item .box_con {
  font-size: 0.14rem;
  color: #333;
  padding-top: 0.4rem;
}
.box_con .appColor {
  color: #4f8cfa;
}
.box_con .red {
  color: #ff3e3e;
}
.squire,
.squire1 {
  display: inline-block;
  background: rgba(79, 140, 250, 1);
  border-radius: 2px;
  width: 0.2rem;
  height: 0.1rem;
  margin-right: 0.05rem;
}
.squire1 {
  background: #ffc16c;
}
.noData_box {
  height: 1rem;
}
.noData {
  background: url("../../assets/img/vip/check/echarts_noData.png") no-repeat top
    center;
  background-size: 100% 100%;
  width: 0.7rem;
  display: inline-block;
  height: 0.7rem;
  position: relative;
  top: 0.23rem;
}
</style>
